import React from 'react';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';

export default function Integration() {
  return (
    <div>
      <PageHeader icon={Icon.integration} title="Integration" subtitle="Connect other tools to TruckFlow" color={SECTION_COLOR.integration} />
      <p className="empty">Connect ELD, accounting, and load board integrations here. Coming soon.</p>
    </div>
  );
}
